// Notification sound using Web Audio API
// Generates a subtle, pleasant notification tone

let audioContext = null;

const getAudioContext = () => {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioContext;
};

const playNotificationSound = () => {
  try {
    const ctx = getAudioContext();

    // Resume context if suspended (browser autoplay policy)
    if (ctx.state === 'suspended') {
      ctx.resume();
    }

    const now = ctx.currentTime;

    // Create a subtle two-tone notification sound
    const oscillator1 = ctx.createOscillator();
    const oscillator2 = ctx.createOscillator();
    const gainNode = ctx.createGain();

    // First tone - higher pitch
    oscillator1.type = 'sine';
    oscillator1.frequency.setValueAtTime(880, now); // A5

    // Second tone - slightly lower
    oscillator2.type = 'sine';
    oscillator2.frequency.setValueAtTime(659.25, now); // E5

    // Connect oscillators to gain
    oscillator1.connect(gainNode);
    oscillator2.connect(gainNode);
    gainNode.connect(ctx.destination);

    // Subtle volume envelope - very quiet and short
    gainNode.gain.setValueAtTime(0, now);
    gainNode.gain.linearRampToValueAtTime(0.08, now + 0.02); // Quick fade in
    gainNode.gain.linearRampToValueAtTime(0.05, now + 0.1);
    gainNode.gain.linearRampToValueAtTime(0, now + 0.25); // Fade out

    // Start and stop
    oscillator1.start(now);
    oscillator2.start(now + 0.05); // Second tone slightly delayed
    oscillator1.stop(now + 0.25);
    oscillator2.stop(now + 0.25);
  } catch (error) {
    // Silently fail if audio is not available
    // eslint-disable-next-line no-console
    console.debug('Notification sound unavailable:', error.message);
  }
};

export default playNotificationSound;
